
export enum DocumentActionType {
  DELETE = 'delete',
  DOWNLOAD = 'download',
  APPROVE = 'approve',
  REJECT = 'reject',
  COMPARE = 'compare',
  PREVIEW = 'preview'
}
